import { HttpClient } from "@angular/common/http";
import { AfterViewInit, Directive, ElementRef, Input } from "@angular/core";
import { UserService } from "@supoui/core/user/user.service";
import { Observable, Subscriber, Subscription, switchMap, tap } from "rxjs";


@Directive({
    selector: '[cache]',
    standalone: false
})
export class ImageCacheDirective implements AfterViewInit {
  @Input() cache: string;

  avatarChangeSubscr: Subscription;

  constructor(public el: ElementRef, private http: HttpClient, private userService: UserService) { 
    this.avatarChangeSubscr = userService.avatarImageChanged$.subscribe(
      () => {
        if ( !!this.cache ) {
          this.removeCachedImage(this.cache)
        }
      }
    );
  }

  ngAfterViewInit() {
      let cachedImage = this.getCachedImage(this.cache);
      if (!!cachedImage) {
          this.setElementImage(cachedImage);
      }
      else {
          this.getImage(this.cache).subscribe(image =>
            this.setElementImage(image)
          )
      }
  }

  getImage(url: string): Observable<any> {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      switchMap(blob => this.cacheImage(url,blob))
    );
  }

  removeCachedImage(url: string) {
    sessionStorage.removeItem(this.getNormalizedUrl(url));
  }

  private getCachedImage(url: string) {
    return sessionStorage.getItem(this.getNormalizedUrl(url));
  }

  private cacheImage(url: string, blob: any): Observable<string> {
    return this.loadBlob(blob).pipe(
      tap(base64 => {
        sessionStorage.setItem(this.getNormalizedUrl(url), base64); 
      })
    );
  }

  private setElementImage(image: any) {
    this.el.nativeElement.src = image;
  }

  private getNormalizedUrl(url: string) {
    const urlObj = new URL(url, location.origin);
    return urlObj.pathname;
  }

  private loadBlob(blob: any): Observable<string> {
    return new Observable((observer: Subscriber<string>): void => {
      const reader = new FileReader();
      reader.addEventListener("loadend", () => {
        // reader.result contains the contents of blob as a typed array
        observer.next(reader.result as string);
        observer.complete();
      });
      reader.addEventListener("error", error => {
        observer.error(error);
      });
      reader.readAsDataURL(blob);
    });
  }
}